export const Colors = {
    black: 'rgb(0,0,0,1)',
    lightGray: 'rgba(189, 189, 189, 1)',
    borderGray: 'rgba(246, 246, 246, 1)',
    backgroundGray: 'rgba(246, 246, 246, 1)',
    red: 'rgb(255,0,0,1)',
    labelBlue: 'rgba(45, 156, 219, 1)',
    navBlue: 'rgba(35, 47, 62, 1)'
}